import { AgGridReact, Flex, Tag, Text } from "@jsq/ds/core";
import { Column } from "@jsq/ds/layouts";
import * as styles from "./styles_vanilla.css";

export const columnDefs: AgGridReact.AgGridReactProps["columnDefs"] = [
  {
    field: "transactionType",
    headerName: "Transaction type",
    cellRenderer: function (params: any) {
      return (
        <Column size="md">
          <Flex
            css={{ width: "100%", alignContent: "flex-start" }}
            flexDirection={"column"}
            gap={4}
          >
            <Text>{params.value}</Text>
          </Flex>
        </Column>
      );
    },
  },
  {
    field: "integrationStartDate",
    headerName: "Integration start date",
    cellRenderer: function (params: any) {
      return (
        <Column size="md">
          <Flex
            css={{ width: "100%", alignContent: "flex-start" }}
            flexDirection={"column"}
            gap={4}
          >
            <Text>{params.value.changedTo}</Text>
            <div>
              {params.value.changedFrom != "" &&
                params.value.changedFrom != params.value.changedTo && (
                  <Tag variant="success" className={styles.Tag}>
                    Updated from {params.value.changedFrom}
                  </Tag>
                )}
            </div>
          </Flex>
        </Column>
      );
    },
  },
  {
    field: "reportingInterval",
    headerName: "Reporting interval",
    cellRenderer: function (params: any) {
      return (
        <Column size="md">
          <Flex
            css={{ width: "100%", alignContent: "flex-start" }}
            flexDirection={"column"}
            gap={4}
          >
            <Text>{params.value.changedTo}</Text>
            <div>
              {params.value.changedFrom != "" &&
                params.value.changedFrom != params.value.changedTo && (
                  <Tag variant="success" className={styles.Tag}>
                    Updated from {params.value.changedFrom}
                  </Tag>
                )}
            </div>
          </Flex>
        </Column>
      );
    },
  },
];

type integrationStartDateType = {
  changedTo: string;
  changedFrom: string;
};

type reportingIntervalType = {
  changedTo: string;
  changedFrom: string;
};

export type ColumnItemType = {
  transactionType: string;
  integrationStartDate: integrationStartDateType;
  reportingInterval: reportingIntervalType;
};

export const gridOptions: AgGridReact.AgGridReactProps["gridOptions"] = {
  autoSizeStrategy: {
    type: "fitGridWidth",
  },
  suppressCellFocus: true,
  suppressRowHoverHighlight: true,
  domLayout: "autoHeight",
  getRowHeight: (params) =>
    (params.data.integrationStartDate.changedFrom &&
      params.data.integrationStartDate.changedFrom !=
        params.data.integrationStartDate.changedTo) ||
    (params.data.reportingInterval.changedFrom &&
      params.data.reportingInterval.changedFrom != params.data.reportingInterval.changedTo)
      ? 66
      : 44,
  defaultColDef: {
    resizable: false,
    sortable: false,
    suppressMenu: true,
  },
};
